"use client";

import { useEffect } from "react";
import { startSessionRenewal } from "@/lib/session-renewal";

/**
 * Renova a sessão enquanto a pessoa usa o ChatADV (CHAT002-4777). Montado uma
 * vez na raiz; sem sessão, não faz nada. A regra inteira (aba visível,
 * interação recente, 15% de vida restante, uma renovação por vez entre abas)
 * está em `lib/session-renewal.ts`.
 */
export function SessionRenewal() {
	useEffect(() => startSessionRenewal(), []);
	return null;
}
